import { MouseEvent, useState } from 'react'

import { MenuPlacement } from '@avantstay/backoffice-core'

const MAX_LIST_HEIGHT = 280
// Core SelectField has an 8px gap, two 8px list margins and two 1px borders.
const MENU_SPACING = 26

export function useSelectMenuPlacement(enabled = true) {
  const [menuPlacement, setMenuPlacement] = useState<MenuPlacement>('bottom')
  const [menuMaxHeight, setMenuMaxHeight] = useState(MAX_LIST_HEIGHT)

  const onMenuClick = (event: MouseEvent<HTMLDivElement>) => {
    if (!enabled) return

    const { top, bottom } = event.currentTarget.getBoundingClientRect()
    let boundaryTop = 0
    let boundaryBottom = window.innerHeight
    let parent = event.currentTarget.parentElement

    while (parent) {
      if (/(auto|scroll|hidden|clip)/.test(window.getComputedStyle(parent).overflowY)) {
        const bounds = parent.getBoundingClientRect()
        boundaryTop = Math.max(boundaryTop, bounds.top)
        boundaryBottom = Math.min(boundaryBottom, bounds.bottom)
      }
      parent = parent.parentElement
    }

    const spaceBelow = boundaryBottom - bottom
    const spaceAbove = top - boundaryTop
    const openAbove = spaceBelow < MAX_LIST_HEIGHT + MENU_SPACING && spaceAbove > spaceBelow
    const availableSpace = openAbove ? spaceAbove : spaceBelow

    setMenuPlacement(openAbove ? 'top' : 'bottom')
    setMenuMaxHeight(Math.max(0, Math.min(MAX_LIST_HEIGHT, availableSpace - MENU_SPACING)))
  }

  return { menuPlacement, menuMaxHeight, onMenuClick }
}
